import { render, staticRenderFns } from "./pro-item.vue?vue&type=template&id=2d6b4d1c&scoped=true&"
import script from "./pro-item.vue?vue&type=script&lang=js&"
export * from "./pro-item.vue?vue&type=script&lang=js&"
import style0 from "./pro-item.vue?vue&type=style&index=0&id=2d6b4d1c&scoped=true&lang=scss&"
import style1 from "./pro-item.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b4d1c",
  null
  
)

export default component.exports